var _circle, _circle2, _circle3, _circle4, _path, _path2, _g, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOpenEmailGraphic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 150,
    cy: 150,
    r: 150,
    fill: "white",
    fillOpacity: 0.3
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 150,
    cy: 150,
    r: 150,
    fill: "#11E8C2"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 150.001,
    cy: 150.001,
    r: 122.727,
    fill: "#11E8C2"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 150.684,
    cy: 150.682,
    r: 98.8636,
    fill: "#11E8C2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M126 107H177",
    stroke: "white",
    strokeWidth: 3.83578,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126 115H177",
    stroke: "white",
    strokeWidth: 3.83578,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1851_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.017 128C142.185 128 135.002 135.183 135.002 144.015C135.002 152.847 142.185 160.022 151.017 160.022C159.849 160.022 167.024 152.839 167.024 144.015C167.024 135.191 159.841 128 151.017 128ZM151.017 156.602C144.071 156.602 138.422 150.953 138.422 144.015C138.422 137.077 144.071 131.42 151.017 131.42C157.963 131.42 163.603 137.069 163.603 144.015C163.603 150.961 157.955 156.602 151.017 156.602Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.456 137.337C156.998 137.37 156.582 137.582 156.28 137.933L148.942 146.455L145.669 143.075C145.35 142.749 144.918 142.561 144.444 142.561C143.995 142.561 143.563 142.732 143.245 143.051C142.575 143.704 142.567 144.789 143.22 145.459L147.783 150.169C148.101 150.503 148.55 150.691 149.015 150.691H149.064C149.546 150.675 149.995 150.462 150.313 150.095L158.876 140.153C159.488 139.443 159.415 138.357 158.696 137.737C158.076 137.247 157.464 137.337 157.464 137.337H157.456Z",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M205.493 142.476C205.493 141.496 204.857 140.681 203.983 140.368L191.788 131.087V93.2621C191.788 92.0119 190.777 91 189.526 91L165.841 91.0053L157.689 91L149.875 91.0107L136.647 91.0053H112.961C111.711 91.0053 110.699 92.0171 110.699 93.2674V131.092L98.5045 140.373C97.6357 140.68 97 141.491 97 142.476V202.82C97 206.401 100.073 209.315 103.85 209.315H198.642C202.42 209.315 205.492 206.401 205.492 202.82L205.493 142.476ZM191.789 136.766L199.29 142.471L191.789 148.182V136.766ZM115.225 95.525H165.053C165.063 95.525 165.074 95.5303 165.084 95.5303C165.095 95.5303 165.1 95.525 165.111 95.525H187.27V151.62L151.248 179.024L115.226 151.62L115.225 95.525ZM110.706 136.766V148.182L103.205 142.476L110.706 136.766ZM101.52 202.656V146.873L138.178 174.764L101.52 202.656ZM106.171 204.796L141.913 177.604L149.88 183.664C150.283 183.971 150.765 184.125 151.247 184.125C151.729 184.125 152.211 183.971 152.614 183.664L160.581 177.604L196.323 204.796H106.171ZM200.975 202.656L164.317 174.765L200.975 146.874V202.656Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1851_775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32.0216,
    height: 32.0216,
    fill: "white",
    transform: "translate(135 128)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEmailGraphic);
export default __webpack_public_path__ + "static/media/open-email-graphic.9b2ead650f9f3433efabb4cdfcde76e9.svg";
export { ForwardRef as ReactComponent };